import * as React from "react";
import {Helmet} from "react-helmet";

export default class HelpPage extends React.Component {

    render() {
        return <div className="ll-help-content">

<Helmet>
    <title>Help</title>
</Helmet>

<h1>Help</h1>

        

        </div>
    }
}
